"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftIconurl = void 0;
const LeftIconurl = exports.LeftIconurl = "data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M13.5667 13.5667L10.1 10.1M6.63335 11.8333C3.76147 11.8333 1.43335 9.50521 1.43335 6.63333C1.43335 3.76145 3.76147 1.43333 6.63335 1.43333C9.50523 1.43333 11.8333 3.76145 11.8333 6.63333C11.8333 9.50521 9.50523 11.8333 6.63335 11.8333Z' stroke='%231d1929'/%3E %3C/svg%3E";